/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * useReconnectOnVisible.ts — us\1 \2econnec\1 \2\1 \2isible (services/operator-web-app).
 */

import { useEffect } from 'react';
import { operatorStore } from '@/store/operatorStore';
import { appConfig } from '@/config/env';

/**
 * E2-S3: When user returns to tab (visibility visible) and operator WS is disconnected,
 * auto-trigger reconnect so they recover after network loss or sleep without clicking "Переподключиться".
 */
export function useReconnectOnVisible(): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return;
      const state = operatorStore.getState();
      if (state.connectionState !== 'disconnected') return;
      operatorStore.getState().connect(appConfig.wsOperatorUrl);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);
}
